(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalizeUrl(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return String(url).split('?')[0];
    }
  }

  function ensureImageLoaded(item) {
    var imgs = item.querySelectorAll('img[data-src]');
    imgs.forEach(function (img) {
      var dataSrc = img.getAttribute('data-src');
      if (dataSrc) {
        img.setAttribute('src', dataSrc.replace('{width}', '920'));
      }
      var dataSrcset = img.getAttribute('data-srcset');
      if (dataSrcset) {
        img.setAttribute('srcset', dataSrcset);
      }
      img.classList.remove('lazyload', 'is-lazy');
      img.classList.add('lazyloaded');
    });
  }

  function injectStyles() {
    if (document.getElementById('norpat-product-gallery-fix-css')) return;
    var style = document.createElement('style');
    style.id = 'norpat-product-gallery-fix-css';
    style.textContent = [
      'body.template-product{overscroll-behavior-x:none;}',
      '.template-product .product-images,.template-product .product-media{overflow-x:hidden!important;overscroll-behavior-x:contain;}',
      '.template-product .product-media-inner.norpat-gallery-fixed{height:auto!important;min-height:0!important;overflow:visible!important;overscroll-behavior-x:contain;touch-action:pan-y;}',
      '.template-product .product-media-inner.norpat-gallery-fixed .product-media-item{display:none!important;opacity:0!important;visibility:hidden!important;height:auto!important;min-height:0!important;overflow:visible!important;}',
      '.template-product .product-media-inner.norpat-gallery-fixed .product-media-item.norpat-gallery-active{display:block!important;opacity:1!important;visibility:visible!important;position:relative!important;left:auto!important;top:auto!important;transform:none!important;height:auto!important;min-height:0!important;overflow:visible!important;}',
      '.template-product .product-media-inner.norpat-gallery-fixed .product-media-item.norpat-gallery-active img{display:block!important;width:100%!important;height:auto!important;max-height:none!important;object-fit:contain!important;-webkit-user-drag:none;user-select:none;}',
      '.template-product .product-thumbnail-wrap.norpat-thumbnail-active .product-thumbnail{outline:2px solid currentColor;outline-offset:2px;}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function initGalleryFix() {
    var productRoot = document.querySelector('[data-section-type="product"]');
    if (!productRoot || productRoot.getAttribute('data-norpat-gallery-fix') === '1') return;

    var mediaWrapper = productRoot.querySelector('[data-product-images]');
    var thumbnailsWrapper = productRoot.querySelector('[data-product-thumbnails]');
    if (!mediaWrapper || !thumbnailsWrapper) return;

    productRoot.setAttribute('data-norpat-gallery-fix', '1');
    mediaWrapper.classList.add('norpat-gallery-fixed');

    function getItems() {
      return Array.prototype.slice.call(mediaWrapper.querySelectorAll('.product-media-item'));
    }

    function getThumbs() {
      return Array.prototype.slice.call(thumbnailsWrapper.querySelectorAll('[data-product-thumbnail-src], [data-media-id]'));
    }

    function findTargetFromThumbnail(thumb) {
      var items = getItems();
      var mediaId = thumb.getAttribute('data-media-id');
      var thumbSrc = thumb.getAttribute('data-product-thumbnail-src') || thumb.getAttribute('src') || '';
      var thumbIndex = parseInt(thumb.getAttribute('data-product-thumbnail-index'), 10);

      if (mediaId) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') === mediaId) return items[i];
        }
      }

      if (thumbSrc) {
        var normalizedThumbSrc = normalizeUrl(thumbSrc);
        for (var j = 0; j < items.length; j++) {
          var itemSrc = items[j].getAttribute('data-product-image-src') || '';
          if (itemSrc === thumbSrc || normalizeUrl(itemSrc) === normalizedThumbSrc) return items[j];
        }
      }

      if (!isNaN(thumbIndex) && thumbIndex > 0 && items[thumbIndex - 1]) {
        return items[thumbIndex - 1];
      }

      return null;
    }

    function findThumbFromTarget(target) {
      if (!target) return null;
      var mediaId = target.getAttribute('data-media-id');
      var targetSrc = target.getAttribute('data-product-image-src') || '';
      var normalizedTargetSrc = normalizeUrl(targetSrc);
      var thumbs = getThumbs();

      for (var i = 0; i < thumbs.length; i++) {
        if (mediaId && thumbs[i].getAttribute('data-media-id') === mediaId) return thumbs[i];
      }

      for (var j = 0; j < thumbs.length; j++) {
        var thumbSrc = thumbs[j].getAttribute('data-product-thumbnail-src') || thumbs[j].getAttribute('src') || '';
        if (targetSrc && (thumbSrc === targetSrc || normalizeUrl(thumbSrc) === normalizedTargetSrc)) return thumbs[j];
      }

      return null;
    }

    function selectMedia(target, activeThumb, focusThumb) {
      var items = getItems();
      items.forEach(function (item) {
        var active = item === target;
        item.classList.toggle('product-single__media--selected', active);
        item.classList.toggle('norpat-gallery-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      ensureImageLoaded(target);

      var selectedThumb = activeThumb || findThumbFromTarget(target);
      var thumbs = getThumbs();
      thumbs.forEach(function (thumb) {
        var wrap = thumb.closest('.product-thumbnail-wrap') || thumb;
        wrap.classList.toggle('norpat-thumbnail-active', thumb === selectedThumb);
      });

      if (focusThumb && selectedThumb) {
        var focusTarget = selectedThumb.closest('.product-thumbnail-wrap') || selectedThumb;
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }
    }

    function getActiveThumbIndex() {
      var thumbs = getThumbs();
      var activeThumb = thumbnailsWrapper.querySelector('.product-thumbnail-wrap.norpat-thumbnail-active [data-product-thumbnail-src], .product-thumbnail-wrap.norpat-thumbnail-active [data-media-id]');
      if (activeThumb) {
        var activeIndex = thumbs.indexOf(activeThumb);
        if (activeIndex >= 0) return activeIndex;
      }

      var activeMedia = mediaWrapper.querySelector('.norpat-gallery-active') || mediaWrapper.querySelector('.product-single__media--selected');
      activeThumb = findThumbFromTarget(activeMedia);
      if (activeThumb) {
        var mediaIndex = thumbs.indexOf(activeThumb);
        if (mediaIndex >= 0) return mediaIndex;
      }

      return 0;
    }

    function selectThumbnail(thumb, focusThumb) {
      var target = findTargetFromThumbnail(thumb);
      if (!target) return false;
      selectMedia(target, thumb, focusThumb);
      return true;
    }

    function navigate(direction, focusThumb) {
      var thumbs = getThumbs();
      if (!thumbs.length) return false;

      var currentIndex = getActiveThumbIndex();
      var nextIndex = currentIndex + direction;
      if (nextIndex < 0) nextIndex = thumbs.length - 1;
      if (nextIndex >= thumbs.length) nextIndex = 0;

      return selectThumbnail(thumbs[nextIndex], focusThumb !== false);
    }

    function stopEvent(event) {
      if (event.cancelable !== false) event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    function restoreScroll(scrollY) {
      if (typeof scrollY !== 'number') return;
      window.scrollTo(0, scrollY);
      window.requestAnimationFrame(function () {
        window.scrollTo(0, scrollY);
      });
    }

    function addSwipeHandler(surface) {
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;
      var startScrollY = 0;
      var tracking = false;
      var horizontalSwipe = false;
      var verticalScroll = false;

      surface.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        lastX = startX;
        lastY = startY;
        startScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        tracking = true;
        horizontalSwipe = false;
        verticalScroll = false;
      }, { capture: true, passive: true });

      surface.addEventListener('touchmove', function (event) {
        if (!tracking || !event.touches || event.touches.length !== 1) return;
        lastX = event.touches[0].clientX;
        lastY = event.touches[0].clientY;
        var dx = lastX - startX;
        var dy = lastY - startY;
        var absX = Math.abs(dx);
        var absY = Math.abs(dy);

        if (!horizontalSwipe && !verticalScroll) {
          if (absY > 12 && absY > absX * 1.1) {
            verticalScroll = true;
            return;
          }
          if (absX > 6 && absX > absY * 1.05) {
            horizontalSwipe = true;
          }
        }

        if (horizontalSwipe) {
          stopEvent(event);
          restoreScroll(startScrollY);
        }
      }, { capture: true, passive: false });

      surface.addEventListener('touchend', function (event) {
        if (!tracking) return;
        var dx = lastX - startX;
        var dy = lastY - startY;
        var absX = Math.abs(dx);
        var absY = Math.abs(dy);
        var wasHorizontal = horizontalSwipe && absX >= 35 && absX >= absY * 1.05;
        tracking = false;
        horizontalSwipe = false;

        if (!wasHorizontal) return;

        var handled = dx < 0 ? navigate(1, false) : navigate(-1, false);
        if (handled) {
          stopEvent(event);
          restoreScroll(startScrollY);
        }
      }, { capture: true, passive: false });

      surface.addEventListener('touchcancel', function () {
        tracking = false;
        horizontalSwipe = false;
        verticalScroll = false;
      }, { capture: true, passive: true });
    }

    var initial = mediaWrapper.querySelector('.product-single__media--selected') || mediaWrapper.querySelector('.product-media-item');
    if (initial) selectMedia(initial, null, false);

    thumbnailsWrapper.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-product-thumbnail-src], [data-media-id]');
      if (!thumb || !thumbnailsWrapper.contains(thumb)) return;

      if (!selectThumbnail(thumb, false)) return;
      stopEvent(event);
    }, true);

    thumbnailsWrapper.addEventListener('keydown', function (event) {
      var handled = false;

      if (event.key === 'Enter' || event.key === ' ') {
        var thumb = event.target.closest('[data-product-thumbnail-src], [data-media-id]');
        if (thumb && thumbnailsWrapper.contains(thumb)) {
          handled = selectThumbnail(thumb, false);
        }
      }

      if (event.key === 'ArrowRight') {
        handled = navigate(1, true);
      }

      if (event.key === 'ArrowLeft') {
        handled = navigate(-1, true);
      }

      if (!handled) return;
      stopEvent(event);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      if (!document.querySelector('[data-section-type="product"][data-norpat-gallery-fix="1"]')) return;

      var target = event.target;
      if (target && target.closest && target.closest('input, textarea, select, button, [contenteditable="true"]')) return;

      var handled = event.key === 'ArrowRight' ? navigate(1, true) : navigate(-1, true);
      if (!handled) return;
      stopEvent(event);
    }, true);

    addSwipeHandler(mediaWrapper);
    addSwipeHandler(thumbnailsWrapper);
  }

  ready(function () {
    injectStyles();
    initGalleryFix();
  });

  document.addEventListener('shopify:section:load', function () {
    injectStyles();
    initGalleryFix();
  });
})();
